const pricingPage = () => {
    // Pobieram elementy formularza i suwaka
    const rangeInput = document.getElementById('listnerRange');
    const numberInput = document.getElementById('listnerNumber');
    const rangeValue = document.getElementById('rangeValue');
    const variantsContainer = document.getElementById('variants');

    if (!rangeInput) return;

    //Pobieram elementy podsumowania wynikow
    const resultListnerNumber = document.getElementById('resultListnerNumber');
    const singlePriceNettoElement = document.getElementById('singlePriceNetto');
    const totalPriceBrutto = document.getElementById('totalPriceBrutto');
    const totalPriceNetto = document.getElementById('totalPriceNetto');

    // Obsluga suwaka
    function updateRangeBackground() {
        const min = rangeInput.min || 0;
        const max = rangeInput.max || 100;
        const value = rangeInput.value;
        const percentage = ((value - min) / (max - min)) * 100;

        const mainColor = '#01579B';
        const strokeColor = '#DFE4EA';

        rangeInput.style.background = `linear-gradient(to right, ${mainColor} 0%, ${mainColor} ${percentage}%, ${strokeColor} ${percentage}%, ${strokeColor} 100%)`;
    }

    // Kalkulator (obliczenia)
    function calculatePrices() {
        const listeners = parseInt(rangeInput.value) || 0;
        const taxRate = 1.23; // VAT

        //Dynamicznie obliczam stawkę bazową z zablokowanych modułów domyślnych
        let totalRatePerListener = 0;

        // Szukam modułów podstawowych (disabled)
        const defaultBoxes = document.querySelectorAll('.pricing-section .form-check-input[disabled]');
        defaultBoxes.forEach(checkbox => {
            totalRatePerListener += parseFloat(checkbox.value) || 0;
        });

        // Pobieram wartości ze wszystkich wybranych checkboxów w sekcji dodatkowych modułów
        if (variantsContainer) {
            const checkedBoxes = variantsContainer.querySelectorAll('.form-check-input:checked');
            checkedBoxes.forEach(checkbox => {
                totalRatePerListener += parseFloat(checkbox.value) || 0;
            });
        }

        //Kalkulacja kosztów końcowych
        const netTotal = listeners * totalRatePerListener;
        const bruttoTotal = netTotal * taxRate;

        // Cena za jednego słuchacza netto
        const netSingle = totalRatePerListener;

        rangeValue.textContent = listeners;
        numberInput.value = listeners;

        // Pozycjonowanie wyniku nad suwakiem
        const min = rangeInput.min || 0;
        const max = rangeInput.max || 100;
        const percent = ((listeners - min) / (max - min)) * 100;
        rangeValue.style.left = `calc(${percent}% - (${percent * 0.2}px - 10px))`;

        // Wstrzykiwanie wyników do html z formatowaniem walutowym
        if (resultListnerNumber) resultListnerNumber.textContent = listeners;
        if (singlePriceNettoElement) singlePriceNettoElement.textContent = netSingle.toFixed(2).replace('.', ',');
        if (totalPriceBrutto) totalPriceBrutto.textContent = bruttoTotal.toFixed(2).replace('.', ',');
        if (totalPriceNetto) totalPriceNetto.textContent = netTotal.toFixed(2).replace('.', ',');
    }

    rangeInput.addEventListener('input', () => {
        updateRangeBackground();
        calculatePrices();
    });

    numberInput.addEventListener('input', function(){
        if (this.value === '') return;

        let val = parseInt(this.value);
        if (val > parseInt(rangeInput.max)) val = rangeInput.max;
        if (val < parseInt(rangeInput.min)) val = rangeInput.min;

        rangeInput.value = val;
        updateRangeBackground();
        calculatePrices();
    });

    if (variantsContainer){
        variantsContainer.addEventListener('change', (e) => {
            if (e.target.classList.contains('form-check-input')) {
                calculatePrices();
            }
        });
    }

    updateRangeBackground();
    calculatePrices();

    //Modal
    const displayResultBtn = document.getElementById('displayResult');

    if (displayResultBtn) {
        displayResultBtn.addEventListener('click', function(e) {

            e.preventDefault();

            const listenersCount = document.getElementById('resultListnerNumber')?.textContent || '0';
            const singlePrice = document.getElementById('singlePriceNetto')?.textContent || '0,00';
            const totalNetto = document.getElementById('totalPriceNetto')?.textContent || '0,00';
            const totalBrutto = document.getElementById('totalPriceBrutto')?.textContent || '0,00';

            document.getElementById('modalListeners').textContent = listenersCount;
            document.getElementById('modalSinglePrice').textContent = singlePrice;
            document.getElementById('modalTotalNetto').textContent = totalNetto;
            document.getElementById('modalTotalBrutto').textContent = totalBrutto;

            const modulesListContainer = document.getElementById('modalModulesList');
            if (modulesListContainer) {
                modulesListContainer.innerHTML = '';

                const allCheckedInputs = document.querySelectorAll('.pricing-section .form-check-input:checked, .pricing-section .form-check-input[disabled]');

                allCheckedInputs.forEach(input => {
                    const label= document.querySelector(`label[for="${input.id}"]`);

                    if (label) {
                        const li =document.createElement('li');
                        li.textContent = label.textContent.trim();
                        if (input.disabled) {
                            li.innerHTML += ' <small class="text-muted">(pakiet podstawowy)</small>';
                        }
                        modulesListContainer.appendChild(li);
                    }
                });
            }

            const summaryModal =new bootstrap.Modal(document.getElementById('summaryModal'));
            summaryModal.show();
        });
    }
}

export { pricingPage };